import { actions } from './form_template/actions'
import { getters } from './form_template/getters'
import { state } from './form_template/state'
import { mutations } from './form_template/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
